export default function PriorityBar({ score = 0 }) {
    const pct = Math.max(0, Math.min(100, (score / 110) * 100));
    return (
        <div className="flex flex-col gap-1 min-w-[70px]">
            <div className="text-sm font-semibold tabular-nums text-ph-text">{score}</div>
            <div className="h-1.5 w-full rounded-full bg-ph-borderSoft overflow-hidden">
                <div
                    className="h-full rounded-full bg-ph-primary"
                    style={{ width: `${pct}%` }}
                />
            </div>
        </div>
    );
}
